define(function (require, exports, module) {
    'use strict';

    var UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     */
    function InternalError(stack, source) {
        UploadError.apply(this, arguments);
    }

    InternalError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: InternalError,
        className: 'InternalError',
        radarName: 'error_{SOURCE}_internal',
        message: 'Внутренняя ошибка сервера.',
        isRetryable: true,
    });

    module.exports = InternalError;
});
